import { Directive, effect, ElementRef, inject, input } from '@angular/core';

/**
 * Aligns a CSS pulse animation to a shared wall-clock so that every element
 * using it stays in phase, regardless of when it was mounted.
 *
 * The animation itself (name/duration/easing) must be declared in CSS; this
 * directive only overrides `animation-delay` with a negative offset derived
 * from `Date.now()`, which puts the animation at the same position on the
 * timeline for all elements.
 */
@Directive({
  selector: '[pulse-sync]',
})
export class PulseSyncDirective {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly periodMs = input<number>(3500, { alias: 'pulse-sync' });

  constructor() {
    effect(() => {
      const period = this.periodMs() || 3500;
      const delay = -(Date.now() % period);
      this.el.nativeElement.style.setProperty('--pulse-sync-delay', `${delay}ms`);
    });
  }
}
